import { Html, Image } from "@custom/schema";
import React from "react";
import ArrowLink from "../molecules/ArrowLink";
export default function ContentWithImage(props) {
    return /*#__PURE__*/ React.createElement("div", {
        className: "bg-gray-30 md:mb-16"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "max-w-5xl mx-auto md:mb-12 px-6 md:px-14 relative"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "lg:flex lg:gap-x-9"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "overflow-hidden"
    }, props.section.map(function(section, key) {
        var _section_ctas;
        /*#__PURE__*/ return React.createElement("div", {
            key: key,
            className: "border-b-2 border-gray-400 last:border-0 mb-10 lg:mb-16 pb-6 md:pb-10 lg:pb-16 last:mb-0"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "md:flex w-full md:gap-x-8 xl:items-center mb-4 md:mb-0"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "mb-3 lg:mb-0"
        }, /*#__PURE__*/ React.createElement("h3", {
            className: "text-xl md:text-2xl lg:text-[1.7rem] font-semibold mt-8 mb-4 md:mt-0"
        }, section === null || section === void 0 ? void 0 : section.heading), /*#__PURE__*/ React.createElement("div", {
            className: "prose lg:text-lg"
        }, (section === null || section === void 0 ? void 0 : section.content) && /*#__PURE__*/ React.createElement(Html, {
            markup: section === null || section === void 0 ? void 0 : section.content
        }), (section === null || section === void 0 ? void 0 : section.boldContent) && /*#__PURE__*/ React.createElement("div", {
            className: "font-medium mt-6 mb-3.5"
        }, /*#__PURE__*/ React.createElement(Html, {
            markup: section === null || section === void 0 ? void 0 : section.boldContent
        }))), (section === null || section === void 0 ? void 0 : section.ctas) && /*#__PURE__*/ React.createElement("div", {
            className: "md:flex mb-4 md:gap-x-3.5"
        }, section === null || section === void 0 ? void 0 : (_section_ctas = section.ctas) === null || _section_ctas === void 0 ? void 0 : _section_ctas.map(function(cta, index) {
            return cta && /*#__PURE__*/ React.createElement("div", {
                key: index,
                className: 'mb-3.5 last:mb-0 after:md:content-["|"] after:md:pl-3.5 after:inline-block after:text-gray-400 last:after:content-[""]'
            }, /*#__PURE__*/ React.createElement(ArrowLink, {
                text: cta.label,
                target: cta.target
            }));
        })), (section === null || section === void 0 ? void 0 : section.subcontent) && /*#__PURE__*/ React.createElement("div", {
            className: "prose"
        }, /*#__PURE__*/ React.createElement(Html, {
            markup: section === null || section === void 0 ? void 0 : section.subcontent
        }))), /*#__PURE__*/ React.createElement("div", {
            className: "max-[767px]:mx-auto mt-8 md:mt-0 mb-6 lg:m-0 w-[190px] shrink-0"
        }, (section === null || section === void 0 ? void 0 : section.sectionImage) && /*#__PURE__*/ React.createElement(Image, {
            source: section === null || section === void 0 ? void 0 : section.sectionImage.source,
            alt: section === null || section === void 0 ? void 0 : section.sectionImage.alt,
            className: "mx-auto md:m-0 w-full"
        }))));
    })))));
}
